import React from 'react';
import ReactStars from 'react-rating-stars-component';
import './ClubReviewModal.css';

export default function ClubReviewModal({
  show,
  handleClose,
  handleSubmit,
  ambienceRating,
  foodRating,
  hygieneRating,
  musicRating,
  pricingRating,
  serviceRating,
  formData,
  handleInputChange,
  handleImageChange,
  handleAmbienceRatingChange,
  handleFoodRatingChange,
  handleHygieneRatingChange,
  handleMusicRatingChange,
  handlePriceRatingChange,
  handleServiceRatingChange,
}) {
  if (!show) return null;

  return (
    <div className="club-modal-overlay">
      <div className="club-modal">
        <div className="club-modal-header">
          <h2>Write a Review</h2>
          <button className="club-modal-close" onClick={handleClose}>
            <i className="fi fi-br-cross"></i>
          </button>
        </div>

        <div className="club-modal-body">
          {[['Ambience', ambienceRating, handleAmbienceRatingChange],
            ['Food', foodRating, handleFoodRatingChange],
            ['Hygiene', hygieneRating, handleHygieneRatingChange],
            ['Music', musicRating, handleMusicRatingChange],
            ['Pricing', pricingRating, handlePriceRatingChange],
            ['Service', serviceRating, handleServiceRatingChange]
          ].map(([label, rating, handler]) => (
            <div key={label} className="club-review-rating-group">
              <p>{label}</p>
              <ReactStars
                count={5}
                size={30}
                activeColor="#ffd700"
                value={rating}
                isHalf={true}
                edit={true}
                onChange={handler}
              />
              <span className="club-rating-score">{rating}</span>
            </div>
          ))}

          <label className="club-input-label">Upload Image</label>
          <input
            type="file"
            name="image"
            onChange={handleImageChange}
            className="club-input-file"
            accept="image/*"
          />

          <label className="club-input-label">Add A Written Review</label>
          <textarea
            className="club-textarea"
            name="msg"
            placeholder="Write your review here"
            value={formData.msg}
            onChange={handleInputChange}
          ></textarea>
        </div>

        <div className="club-modal-footer">
          <button className="club-submit-btn" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
}
